import React from "react";
import "./App.css";
import DishUI from "./Dishes/DishUI";
import BillSummary from "./BillSummary";
import { Helmet } from "react-helmet";
import OpeningMessage from "./components/OpeningMessage";
import logo from "./Img/SUSHIRO_logo_alphabet.png";

import useBillCalculator from "./hooks/useBillCalculator";
import useDelayedFlag from "./hooks/useDelayedFlag";

function App() {
  const isAnimationRunning = useDelayedFlag(3000);

  const { dishes, quantities, eachPersonBillSummary, totals, actions } =
    useBillCalculator();

  return (
    <div>
      <Helmet>
        <title>Panne - Sushiro Calculator</title>
         <meta 
          name="description" 
          content="เครืิ่องคิดเลขซูชิโระ sushiro calculator" 
        />
      </Helmet>
      

      {!isAnimationRunning && <OpeningMessage />}

      {isAnimationRunning && (
        <header>
          <div className="container">
            <img className="logo" src={logo} alt="Logo" />
            <h1>Calculator</h1>

            <DishUI
              dishes={dishes}
              quantities={quantities}
              addDish={actions.addDish}
              minusDish={actions.minusDish}
              addCustomDish={actions.addCustomDish}
            />


            <BillSummary
              SubTotal={totals.SubTotal}
              serviceCharge={totals.serviceCharge}
              totalPriceWithServiceCharge={totals.totalPriceWithServiceCharge}
              eachPersonBillSummary={eachPersonBillSummary}
              resetCalculator={actions.resetCalculator}
              undoLastAction={actions.undoLastAction}
              calculateNextPersonBill={actions.calculateNextPersonBill}
            />
          </div>
        </header>
      )}
    </div>
  );
}

export default App;
